export default __webpack_public_path__ + "static/media/bra-material-1.23340a63.webp";